module.exports = "/_next/static/images/favicon-32-b24b9a3ceb998bc7b0841b6043f5514d.png";